<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      @if (!showPropertyFeatureTemplate) {
        <div class="row m-0">
          <div class="col-lg-12">
            @if (formAlert) {
              <div class="w-100 mb-3">
                <div class="w-100"
                  style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                  <p><b>{{formAlert}}</b></p>
                </div>
              </div>
            }
          </div>
          <div class="col-lg-6">
            <span class="p-float-label required-field w-100 mb-3">
              <input formControlName="title" id="title" type="text" pInputText>
              <label for="title">Title</label>
              @for (validation of validationMessages.title; track validation) {
                <span>
                  @if (form1.get('title').hasError(validation.type) && (form1.get('title').dirty || form1.get('title').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <div class="col-lg-6">
            <span class="p-float-label required-field w-100 mb-3">
              <p-dropdown [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
                optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false"
                placeholder="Select Property">
              </p-dropdown>
              <label for="Select Property">Select Property</label>
              @for (validation of validationMessages.shortTermRentalId; track validation) {
                <span>
                  @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <div class="col-lg-6">
            <span class="p-float-label required-field w-100 mb-3">
              <input formControlName="name" id="name" type="text" pInputText>
              <label for="name">Name</label>
              @for (validation of validationMessages.name; track validation) {
                <span>
                  @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <div class="col-lg-6">
            <span class="p-float-label required-field w-100 mb-3">
              <input formControlName="developmentId" id="developmentId" type="text" pInputText>
              <label for="developmentId">DevelopmentId</label>
              @for (validation of validationMessages.developmentId; track validation) {
                <span>
                  @if (form1.get('developmentId').hasError(validation.type) && (form1.get('developmentId').dirty || form1.get('developmentId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <div class="col-lg-6">
            <span class="p-float-label w-100 mb-3">
              <input formControlName="featureType" id="featureType" type="text" pInputText>
              <label for="featureType">feature Type</label>
              @for (validation of validationMessages.featureType; track validation) {
                <span>
                  @if (form1.get('featureType').hasError(validation.type) && (form1.get('featureType').dirty || form1.get('featureType').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <div class="col-lg-6">
            <span class="p-float-label w-100 mb-3">
              <input formControlName="activityId" id="activityId" type="number" pInputText>
              <label for="activityId">activityId</label>
              @for (validation of validationMessages.activityId; track validation) {
                <span>
                  @if (form1.get('activityId').hasError(validation.type) && (form1.get('activityId').dirty || form1.get('activityId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <div class="col-lg-6">
            <span class="p-float-label w-100 mb-3">
              <input formControlName="guestBookId" id="guestBookId" type="text" pInputText>
              <label for="guestBookId">Guest Book Id</label>
              @for (validation of validationMessages.guestBookId; track validation) {
                <span>
                  @if (form1.get('guestBookId').hasError(validation.type) && (form1.get('guestBookId').dirty || form1.get('guestBookId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <div class="col-lg-6">
            <span class="p-float-label w-100 mb-3">
              <input formControlName="featureLabel" id="featureLabel" type="text" pInputText>
              <label for="featureLabel">feature Label</label>
              @for (validation of validationMessages.featureLabel; track validation) {
                <span>
                  @if (form1.get('featureLabel').hasError(validation.type) && (form1.get('featureLabel').dirty || form1.get('featureLabel').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <div class="col-lg-6">
            <span class="p-float-label w-100 mb-3">
              <input formControlName="defaultFeature" id="defaultFeature" type="text" pInputText>
              <label for="defaultFeature">Default Feature</label>
              @for (validation of validationMessages.defaultFeature; track validation) {
                <span>
                  @if (form1.get('defaultFeature').hasError(validation.type) && (form1.get('defaultFeature').dirty || form1.get('defaultFeature').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <!-- <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="highlight" id="highlight" type="number" pInputText>
            <label for="highlight">Highlight</label>
            <span *ngFor="let validation of validationMessages.highlight">
              <small class="p-invalid"
                *ngIf="form1.get('highlight').hasError(validation.type) && (form1.get('highlight').dirty || form1.get('highlight').touched)">{{validation.message}}
              </small>
            </span>
          </span>
        </div> -->
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="highlights" formControlName="highlight" optionLabel="name"
              optionValue="value" placeholder="Select Highlight">
            </p-dropdown>
            <label for="highlight">Select Highlight</label>
            @for (validation of validationMessages.highlight; track validation) {
              <span>
                @if (form1.get('highlight').hasError(validation.type) && (form1.get('highlight').dirty || form1.get('highlight').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="quantity" id="quantity" type="number" pInputText>
            <label for="quantity">Quantity</label>
            @for (validation of validationMessages.quantity; track validation) {
              <span>
                @if (form1.get('quantity').hasError(validation.type) && (form1.get('quantity').dirty || form1.get('quantity').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="distance" id="distance" type="number" pInputText>
            <label for="distance">Distance</label>
            @for (validation of validationMessages.distance; track validation) {
              <span>
                @if (form1.get('distance').hasError(validation.type) && (form1.get('distance').dirty || form1.get('distance').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="distanceUnit" id="distanceUnit" type="number" pInputText>
            <label for="distanceUnit">Distance Unit</label>
            @for (validation of validationMessages.distanceUnit; track validation) {
              <span>
                @if (form1.get('distanceUnit').hasError(validation.type) && (form1.get('distanceUnit').dirty || form1.get('distanceUnit').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="describesType" id="describesType" type="text" pInputText>
            <label for="describesType">Describes Type</label>
            @for (validation of validationMessages.describesType; track validation) {
              <span>
                @if (form1.get('describesType').hasError(validation.type) && (form1.get('describesType').dirty || form1.get('describesType').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="featureDesc" id="featureDesc" [rows]="1" pInputTextarea></textarea>
            <label for="featureDesc">feature Description</label>
            @for (validation of validationMessages.featureDesc; track validation) {
              <span>
                @if (form1.get('featureDesc').hasError(validation.type) && (form1.get('featureDesc').dirty || form1.get('featureDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="privateNotes" id="privateNotes" [rows]="1" pInputTextarea></textarea>
            <label for="privateNotes">Private Notes</label>
            @for (validation of validationMessages.privateNotes; track validation) {
              <span>
                @if (form1.get('privateNotes').hasError(validation.type) && (form1.get('privateNotes').dirty || form1.get('privateNotes').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="kbmMap" id="kbmMap" type="text" pInputText>
            <label for="kbmMap">KBM Map</label>
            @for (validation of validationMessages.kbmMap; track validation) {
              <span>
                @if (form1.get('kbmMap').hasError(validation.type) && (form1.get('kbmMap').dirty || form1.get('kbmMap').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="vrboMap" id="vrboMap" type="text" pInputText>
            <label for="quantity">Vrbo Map</label>
            @for (validation of validationMessages.quantity; track validation) {
              <span>
                @if (form1.get('quantity').hasError(validation.type) && (form1.get('quantity').dirty || form1.get('quantity').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="rentalsUnitedMap" id="rentalsUnitedMap" type="text" pInputText>
            <label for="rentalsUnitedMap">Rentals UnitedMap</label>
            @for (validation of validationMessages.rentalsUnitedMap; track validation) {
              <span>
                @if (form1.get('rentalsUnitedMap').hasError(validation.type) && (form1.get('rentalsUnitedMap').dirty || form1.get('rentalsUnitedMap').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <h6 for="status">Status Options</h6>
          <div class="flex align-items-center">
            <p-checkbox [formControl]="form1.controls['status']" inputId="status" [binary]="true"></p-checkbox>
            <span class="test-nm">Is Status?</span>
          </div>
          @for (validation of validationMessages.status; track validation) {
            <span>
              @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>
      </div>
    }
    @if (showPropertyFeatureTemplate) {
      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="propertyFeatures" formControlName="propertyFeatureTemplateId" optionLabel="templateName"
            optionValue="propertyFeatureTemplateId" [filter]="true" filterBy="templateName" [showClear]="false" appendTo="body"
            placeholder="Select Property Feature Template">
          </p-dropdown>
          <label for="Select Property Feature Template">Select Property Feature Template</label>
          @for (validation of validationMessages.propertyFeatureTemplateId; track validation) {
            <span>
              @if (form1.get('propertyFeatureTemplateId').hasError(validation.type) && (form1.get('propertyFeatureTemplateId').dirty || form1.get('propertyFeatureTemplateId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    }
  </div>
  <hr>
    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>

          @if (!propertyFeatureId && !showPropertyFeatureTemplate) {
            <button pButton class="btn-addt p-button" (click)="formAdd()">Add Property Feature</button>
          }

          @if (!propertyFeatureId && showPropertyFeatureTemplate) {
            <button pButton class="btn-addt p-button" (click)="onOpenFormAdd()">New Property Feature Template+</button>
          }

          @if (!propertyFeatureId && showPropertyFeatureTemplate) {
            <button pButton class="btn-addt p-button" (click)="addToTemplate()">Submit</button>
          }

          @if (propertyFeatureId && !showPropertyFeatureTemplate) {
            <button pButton  class="btn-upt p-button" (click)="copyToFeature()">Copy To</button>
          }

          @if (propertyFeatureId && !showPropertyFeatureTemplate) {
            <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Property Feature</button>
          }
        </div>
      </div>
    </div>
  </div>